module.exports = __webpack_public_path__ + "static/escolas-0599cdfadc77c3f7d84d5df38dba78b1.png";